<template>
  <MultiLvSelect ref="MultiLvSelect" :data="industryInfo" :props="props" v-bind="$attrs" v-on="$listeners" />
</template>

<script>
import { mapState } from 'vuex'
import MultiLvSelect from './index'
export default {
  name: 'IndustrySelect',
  components: {
    MultiLvSelect
  },
  props: {
  },
  data() {
    return {
      sortSelectArea: [],
      props: {
        value: 'industryCode',
        label: 'industry',
      }
    }
  },
  computed: {
    ...mapState({
      industryInfo: state => state.asyncRoute.industryInfo,
    }),
  },
  watch: {
    industryInfo: {
      deep: true,
      immediate: true,
      handler: function (val) {
        this.sortSelectArea = this.industryInfo
      }
    },
  },
  mounted() {
  },
  methods: {

  },
}
</script>

<style scoped lang="scss">
</style>
